import React, { useEffect, useState } from "react";
import { httpAdmin, limitToTwoDecimal } from "../../../Apis/commonApis";
import {
  formatDate,
  getCurrentTimeZone,
  getFullName,
  getNameChars,
} from "../../../utils/CommonFunctions";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { CircularProgress } from "@mui/material";
import swal from "sweetalert";
import { ShowSwal } from "../../../utils/alertSwal";
import { useSelector } from "react-redux";

const AssignStaffNew = (props) => {
  const { assignStaffEvent, getShiftsandtaskNew, groupArr } = props;

  const { socketReloadCount } = useSelector(
    (state) => state.caresiteDataReducer
  );

  const [adminAcceptedStaff] = useState({
    "shift-1": [],
    "shift-2": [
      {
        id: 9,
        name: "John Mitchell",
        title: "Senior Carer",
        acceptedTime: "1 day ago",
        distance: "1.9 miles",
        performance: 95,
        shiftHrs: 8,
        clientGroup: "Group C",
      },
      {
        id: 10,
        name: "Kate Williams",
        title: "Supervisor",
        acceptedTime: "2 days ago",
        distance: "3.1 miles",
        performance: 88,
        shiftHrs: 6,
        clientGroup: "Group C",
      },
    ],
    "shift-3": [],
  });

  const [staffData, setStaffData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentShiftId, setCurrentShiftId] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [assignStaffToggle, setAssignStaffToggle] = useState(false);
  const [openShiftToggle, setOpenShiftToggle] = useState(false);
  const [jobFilter, setJobFilter] = useState("all");
  const [criteriaFilter, setCriteriaFilter] = useState("weeklyHoursAssigned");
  const [openShiftGroup, setOpenShiftGroup] = useState("all");
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    title: "",
    message: "",
  });

  useEffect(() => {
    getAvailableCareTeam();
  }, [jobFilter, criteriaFilter]);

  useEffect(() => {
    getAssignedData([], "refresh");
  }, [socketReloadCount]);

  const getAvailableCareTeam = async () => {
    const selectedDate = assignStaffEvent.date.includes("T")
      ? assignStaffEvent.date.split("T")[0]
      : assignStaffEvent.date;
    const startDate = new Date(selectedDate)?.toISOString();
    const data = {
      careSiteId: currentCareSiteId,
      priorityBasedOn: criteriaFilter,
      shiftName: assignStaffEvent.shift,
      jobTitle: jobFilter,
      shiftDates: [
        {
          date: startDate,
        },
      ],
      startDate: startDate,
      endDate: startDate,
    };
    const res = await httpAdmin("availableCareMember", "post", data, null);
    if (res.status) {
      let teamdata = [];
      res.data?.forEach((item) => {
        teamdata.push({
          id: item._id,
          name: getFullName(item),
          //  `${item.first_Name} ${item.last_Name}`,
          image: item.image,
          avatar: getNameChars(item),
          jobTitle: item.jobTitle ?? "",
          title: item.jobTitle ?? "",
          role: item.jobTitle ?? "",
          shiftHours: item.shiftHours ? limitToTwoDecimal(+item.shiftHours) : 0,
          hours: item.shiftHours ? limitToTwoDecimal(+item.totalHours) : 0,
          averagePerformance: item.averagePerformance
            ? limitToTwoDecimal(+item.averagePerformance)
            : 0,
          performance: item.averagePerformance
            ? limitToTwoDecimal(+item.averagePerformance)
            : 0,
          distance: item.distance ? limitToTwoDecimal(+item.distance) : "0",
          clientGroup: "all",
          groupName: "all",
          selected: false,
          showCriteriaFilters: true,
        });
      });
      // teamdata.push(assignedStaff);
      getAssignedData(teamdata);
    } else {
      getAssignedData([]);
    }
  };

  const getAssignedData = async (availableTeams, type) => {
    const selectedDate = assignStaffEvent.date.includes("T")
      ? assignStaffEvent.date.split("T")[0]
      : assignStaffEvent.date;
    const endpoint = `getShiftConfig?careHomeId=${currentCareSiteId}&shiftDate=${selectedDate}&shiftName=${assignStaffEvent.shift}`;
    const res = await httpAdmin(endpoint, "get", null, null);
    if (res.status) {
      const assignedData = res.shiftData[0]?.shiftMappings;
      const shiftData = res.shiftData?.[0];
      if (shiftData?.recurringShiftType === "open") {
        setOpenShiftToggle(true);
        setAssignStaffToggle(false);
        setOpenShiftGroup(shiftData.openShiftZone);
      } else if (shiftData?.recurringShiftType === "assigned") {
        setAssignStaffToggle(true);
        setOpenShiftToggle(false);
      }
      if (type === "refresh") {
        setStaffData((prev) =>
          prev.map((s) => {
            const findStaff =
              assignedData.find((aItem) => aItem.careTeamId === s.id) || {};
            return { ...prev, ...findStaff };
          })
        );
      } else {
        const assignedStaff = assignedData?.map((shiftItem) => {
          const findSelectedZone = groupArr.find((gItem) =>
            gItem.groupName?.includes(shiftItem.zone)
          );
          const groupId = findSelectedZone?.groupId
            ? findSelectedZone?.groupId
            : shiftItem.all
            ? "all"
            : shiftItem.clientId[0];
          const groupName = findSelectedZone?.groupName
            ? findSelectedZone?.groupName
            : shiftItem.all
            ? "All Client"
            : `${getFullName(shiftItem.client[0])} - Temp`;
          const careteam = shiftItem?.careteam;
          return {
            ...shiftItem,
            id: shiftItem.careTeamId,
            name: getFullName(careteam),
            avatar: getNameChars(careteam),
            image: careteam?.image,
            jobTitle: careteam?.jobTitle ?? "",
            title: careteam?.jobTitle ?? "",
            role: careteam?.jobTitle ?? "",
            hours: -1,
            performance: 1000,
            distance: -1,
            clientGroup: groupId,
            groupName,
            selected: true,
            _id: shiftItem._id,
            shiftId: shiftItem.shiftId,
            showCriteriaFilters: false,
            isDeclined: false,
          };
        });
        setStaffData([...availableTeams, ...assignedStaff]);
      }
    } else {
      setStaffData(availableTeams);
    }
  };

  const closePopup = () => {
    getShiftsandtaskNew("createOrEdit");
  };

  const toggleAssignStaff = () => {
    const newValue = !assignStaffToggle;
    setAssignStaffToggle(newValue);

    if (newValue) {
      setOpenShiftToggle(false);

      // Add admin accepted staff
      const accepted = adminAcceptedStaff[currentShiftId] || [];
      const newSelectedStaff = [...selectedStaff];
      accepted.forEach((staff) => {
        if (!newSelectedStaff.find((s) => s.id === staff.id)) {
          newSelectedStaff.push({
            id: staff.id,
            name: staff.name,
            clientGroup: staff.clientGroup,
          });
        }
      });
      setSelectedStaff(newSelectedStaff);
    } else {
      setStaffData((prev) =>
        prev.map((s) => ({ ...s, selected: false, isDeclined: false }))
      );
      setSelectedStaff([]);
    }
  };

  const toggleOpenShift = () => {
    const newValue = !openShiftToggle;
    setOpenShiftToggle(newValue);

    if (newValue) {
      setAssignStaffToggle(false);
      setSelectedStaff([]);
    } else {
      setAssignStaffToggle(true);
    }
  };

  const toggleStaffSelection = (staffId) => {
    setStaffData((prev) =>
      prev.map((s) =>
        s.id === staffId
          ? { ...s, selected: !s.selected, isDeclined: false }
          : s
      )
    );
  };

  const updateClientGroup = (staff, clientGroup) => {
    const selectedGroup = groupArr.find(
      (gItem) => gItem.groupId === clientGroup
    );
    setStaffData((prev) =>
      prev.map((s) =>
        s.id === staff.id
          ? {
              ...s,
              clientGroup,
              groupName: selectedGroup?.groupName ?? "All Client",
            }
          : s
      )
    );
  };

  const getCurrentAssignment = () => {
    const filterSelectedStaff = staffData?.filter((sItem) => sItem.selected);
    if (openShiftToggle) {
      const selectedGroup = groupArr.find(
        (gItem) => gItem.groupId === openShiftGroup
      );
      const groupName = selectedGroup?.groupName ?? "All Client";
      const accepted = staffData?.filter((sItem) => sItem.shiftApprovalstatus);

      if (accepted.length > 0) {
        const staffNames = accepted.map((s) => s.name).join(", ");
        return `Open Shift (${groupName}) - ${staffNames}`;
      } else {
        return `Open Shift (${groupName})`;
      }
    } else if (filterSelectedStaff?.length > 0) {
      const staffText = filterSelectedStaff
        .map((s) => `${s.name}${s.groupName ? ` (${s.groupName})` : ""}`)
        .join(", ");
      return staffText;
    } else {
      return "Unassigned";
    }
  };

  const saveAssignment = () => {
    const staffWithoutGroups = [];

    if (staffWithoutGroups.length > 0) {
      const staffNames = staffWithoutGroups.map((s) => s.name).join(", ");
      setErrorMessage(
        `Please select client groups for the following staff members: ${staffNames}`
      );
      return;
    }
    assignStaffApi();
  };

  const assignStaffApi = async () => {
    setLoading(true);
    let teamDataArr = [];
    let userTimezone = getCurrentTimeZone();
    const shiftstart = assignStaffEvent?.shiftTime?.split("-")[0]?.trim();
    const shiftend = assignStaffEvent?.shiftTime?.split("-")[1]?.trim();
    const selectedDate = assignStaffEvent.date.includes("T")
      ? assignStaffEvent.date.split("T")[0]
      : assignStaffEvent.date;
    staffData?.forEach((sItem) => {
      if (sItem.selected) {
        teamDataArr.push({
          innerShiftType: sItem?._id ? "old" : "new",
          careTeamId: sItem.id,
          clientId: sItem?.clientGroup,
          all: sItem?.clientGroup === "all",
          timing: "within time",
          startTime: "",
          endTime: "",
        });
      } else if (sItem._id && sItem?.isDeclined) {
        teamDataArr.push({
          decline: true,
          // innerShiftType: sItem?._id ? "old" : "new",
          careTeamId: sItem.id,
          clientId: sItem?.clientGroup,
          all: sItem?.clientGroup === "all",
          timing: "within time",
          startTime: "",
          endTime: "",
        });
      }
    });
    let assignData = {
      careHomeId: currentCareSiteId,
      shiftName: assignStaffEvent.shift,
      shiftDate: selectedDate,
      timeZone: userTimezone,
      recurringShiftType: openShiftToggle ? "open" : "assigned",
      assignedCareTeam: teamDataArr,
    };
    if (openShiftToggle) {
      assignData.openShiftStart = shiftstart;
      assignData.openShiftEnd = shiftend;
      assignData.openShiftZone = openShiftGroup;
    }
    const res = await httpAdmin(`editShiftConfig`, "post", assignData, null);
    ShowSwal(res.status, res?.message ?? "");
    if (res.status) {
      getShiftsandtaskNew("createOrEdit");
    }
    setLoading(false);
  };

  const renderStaffList = () => {
    // Filter staff based on job title
    let filteredStaff = staffData;

    // Sort staff based on criteria
    filteredStaff.sort((a, b) => {
      switch (criteriaFilter) {
        case "hours":
          return a.hours - b.hours;
        case "distance":
          return a.distance - b.distance;
        case "performance":
          return b.performance - a.performance;
        default:
          return a.hours - b.hours;
      }
    });

    if (filteredStaff.length === 0) {
      return <div>No Careteam available for selected shift and filters.</div>;
    }

    return filteredStaff.map((staff) => {
      const isShowCriteria = staff.showCriteriaFilters;
      const criteriaFilterNew = isShowCriteria ? criteriaFilter : "no";
      let criteriaInfo = "";
      switch (criteriaFilterNew) {
        case "weeklyHoursAssigned":
          criteriaInfo = `• Shift Hrs: ${staff.hours}`;
          break;
        case "distance":
          criteriaInfo = `• ${staff.distance} miles`;
          break;
        case "performance":
          criteriaInfo = `• Performance: ${staff.performance}%`;
          break;
        default:
          criteriaInfo = ``;
      }

      const handleChangeStaffSelect = () => {
        if (staff?.checkinDateTime) {
          showErrorModal(
            "Cannot remove.",
            "Member cannot be removed after clock-in."
          );
        } else if (staff?._id && staff.selected) {
          swal({
            title: "Confirmation!",
            text: "Is shift declined by the care team member?",
            buttons: {
              cancel: "No",
              succeed: "Yes",
            },
          }).then((result) => {
            if (result) {
              setStaffData((prev) =>
                prev.map((s) =>
                  s.id === staff.id
                    ? { ...s, selected: !s.selected, isDeclined: true }
                    : s
                )
              );
            } else {
              toggleStaffSelection(staff.id);
            }
          });
        } else {
          toggleStaffSelection(staff.id);
        }
      };

      return (
        <div
          key={staff.id}
          className={`staff-item ${staff.selected ? "selected" : ""}`}
        >
          <input
            type="checkbox"
            className="staff-checkbox"
            checked={staff.selected}
            onChange={handleChangeStaffSelect}
          />
          <div className="staff-info">
            <div className="staff-name">{staff.name}</div>
            <div className="staff-title">
              {staff.title} {criteriaInfo}
            </div>
          </div>
          <select
            className="client-group-select"
            value={staff?.clientGroup || "all"}
            onChange={(e) => updateClientGroup(staff, e.target.value)}
            disabled={!staff.selected || staff?.checkinDateTime}
          >
            <option value="all">All Client</option>
            {groupArr?.map((elem) => {
              return (
                <option key={elem.groupId} value={elem.groupId}>
                  {elem.groupName}
                </option>
              );
            })}
          </select>
        </div>
      );
    });
  };

  const renderAcceptedStaff = () => {
    console.log(staffData, "ssssssssss");
    const accepted = staffData?.filter(
      (sItem) => sItem.shiftApprovalstatus && sItem.selected
    );

    if (accepted.length === 0) {
      return (
        <div className="no-accepted-staff">
          No staff have been accepted for this open shift yet by the admin from
          the Admin Portal Dashboard
        </div>
      );
    }

    return accepted.map((staff) => {
      return (
        <div key={staff.id} className="accepted-staff-item">
          <div className="accepted-avatar">
            {staff.image ? (
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                  borderRadius: "25px",
                }}
                src={staff.image}
                alt="img"
              />
            ) : (
              staff.avatar
            )}
          </div>
          <div className="accepted-staff-info">
            <div className="accepted-staff-name">{staff.name}</div>
            <div className="accepted-staff-details">
              <span>{staff.title}</span>
              <span>Accepted {formatDate(staff.shiftApprovalTimestamp)}</span>
              {/* <span>{staff.distance} away</span>
              <span>Performance: {staff.performance}%</span>
              <span>Shift Hrs: {staff.hrs}</span> */}
            </div>
          </div>
          <div className="accepted-badge">Accepted</div>
          <button
            className="btn-unassign"
            onClick={() => toggleStaffSelection(staff.id)}
          >
            Unassign
          </button>
        </div>
      );
    });
  };

  const showErrorModal = (title, message) => {
    setErrorModal({
      show: true,
      title,
      message,
    });
  };

  const closeErrorModal = () => {
    setErrorModal({
      show: false,
      title: "",
      message: "",
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popup {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 750px;
          max-height: 85vh;
          overflow-y: auto;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        }

        .popup-header {
          background: #6f42c1;
          color: white;
          padding: 20px;
          border-radius: 12px 12px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .popup-title {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
        }

        .close-btn {
          background: none;
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-btn:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .popup-content {
          padding: 20px;
        }

        .shift-summary {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 20px;
          border-left: 4px solid #6f42c1;
        }

        .shift-summary h2 {
          margin-bottom: 10px;
          color: #2c3e50;
          font-size: 16px;
        }

        .shift-summary-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 10px;
          font-size: 14px;
        }

        .current-assignments {
          background: #e8f5e8;
          border: 1px solid #c3e6c3;
          border-radius: 6px;
          padding: 15px;
          margin-bottom: 20px;
        }

        .current-assignments h4 {
          margin-bottom: 10px;
          color: #2c3e50;
          font-size: 14px;
          font-weight: 600;
        }

        .assignment-item {
          padding: 8px 12px;
          background: white;
          border-radius: 4px;
          border: 1px solid #d4edda;
          font-size: 13px;
          color: #000;
        }

        .section-title {
          font-size: 16px;
          font-weight: 500;
          color: #2c3e50;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .toggle-container {
          display: flex;
          gap: 20px;
          margin-bottom: 20px;
        }

        .toggle-option {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .toggle-switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 24px;
        }

        .toggle-switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: 0.4s;
          border-radius: 34px;
          height: auto;
          width: auto;
          opacity: 1;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 18px;
          width: 18px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: 0.4s;
          border-radius: 50%;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #6f42c1;
        }

        input:checked + .slider:before {
          transform: translateX(26px);
        }

        .assignment-section {
          margin-bottom: 25px;
        }

        .staff-filters {
          display: flex;
          gap: 15px;
          margin-bottom: 20px;
        }

        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .filter-group label {
          font-size: 14px;
          font-weight: 500;
          color: #495057;
        }

        .filter-group select {
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 14px;
          background: white;
          min-width: 140px;
        }

        .staff-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 12px;
          max-height: 280px;
          overflow-y: auto;
          border: 1px solid #dee2e6;
          border-radius: 6px;
          padding: 15px;
          background: #fafafa;
        }

        .staff-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          background: white;
          border-radius: 6px;
          border: 1px solid #dee2e6;
        }

        .staff-item.selected {
          background: #e3f2fd;
          border-color: #6f42c1;
        }

        .staff-checkbox {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        .staff-info {
          flex: 1;
        }

        .staff-name {
          font-weight: 500;
          color: #2c3e50;
          font-size: 14px;
        }

        .staff-title {
          font-size: 12px;
          color: #6c757d;
        }

        .client-group-select {
          width: 150px;
          padding: 6px 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 12px;
        }

        .open-shift-section {
          display: none;
        }

        .open-shift-section.active {
          display: block;
        }

        .open-shift-group {
          margin-bottom: 15px;
        }

        .open-shift-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #495057;
        }

        .open-shift-group select {
          width: 200px;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-size: 14px;
        }

        .accepted-staff-section h4 {
          margin-bottom: 15px;
          color: #2c3e50;
          font-size: 14px;
        }

        .accepted-staff-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .accepted-staff-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          background: #e8f5e8;
          border: 1px solid #c3e6c3;
          border-radius: 6px;
        }

        .accepted-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #28a745;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 14px;
        }

        .accepted-staff-info {
          flex: 1;
        }

        .accepted-staff-name {
          font-weight: 500;
          color: #2c3e50;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .accepted-staff-details {
          font-size: 12px;
          color: #6c757d;
          display: flex;
          gap: 15px;
        }

        .accepted-badge {
          background: #28a745;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .btn-unassign {
          background: #dc3545;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 11px;
        }

        .btn-unassign:hover {
          background: #c82333;
        }

        .no-accepted-staff {
          text-align: center;
          padding: 30px;
          color: #6c757d;
          font-style: italic;
          border: 2px dashed #dee2e6;
          border-radius: 6px;
          background: #f8f9fa;
        }

        .popup-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding: 20px;
          border-top: 1px solid #dee2e6;
          background: #f8f9fa;
          border-radius: 0 0 12px 12px;
        }

        .btn {
          padding: 7px 20px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
        }

        .btn-secondary {
          background: #6c757d;
          color: white;
        }

        .btn-secondary:hover {
          background: #5a6268;
        }

        .btn-primary {
          background: #9e61e7;
          color: white;
        }

        .btn-primary:hover {
          background: #5a359a;
        }

        .hidden {
          display: none !important;
        }
      `}</style>

      {/* Assignment Popup */}
      <div>
        <div style={{ padding: "20px" }}>
          {/* Shift Summary */}
          <div className="shift-summary">
            <h2 style={{ fontWeight: "700" }}>
              <strong>{assignStaffEvent?.shift}</strong>
            </h2>
            <div className="shift-summary-grid" style={{ color: "#000" }}>
              <div>
                <strong style={{ fontWeight: "700" }}>Date:</strong>{" "}
                {assignStaffEvent?.date}
              </div>
              <div>
                <strong style={{ fontWeight: "700" }}>Time:</strong>{" "}
                {assignStaffEvent?.shiftTime}
              </div>
              <div>
                <strong style={{ fontWeight: "700" }}>Break:</strong>{" "}
                {assignStaffEvent?.shiftBreak} min
              </div>
            </div>
          </div>

          {/* Current Assignment */}
          <div className="current-assignments">
            <h4>Current Assignment</h4>
            <div className="assignment-item">{getCurrentAssignment()}</div>
          </div>

          {/* Assignment Options */}
          <div className="assignment-section">
            <div className="section-title">Assignment Options</div>

            <div className="toggle-container">
              <div className="toggle-option">
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={assignStaffToggle}
                    onChange={toggleAssignStaff}
                  />
                  <span className="slider"></span>
                </label>
                <label>Assign Staff</label>
              </div>

              <div className="toggle-option">
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={openShiftToggle}
                    onChange={toggleOpenShift}
                  />
                  <span className="slider"></span>
                </label>
                <label>Open Shift</label>
              </div>
            </div>
          </div>

          {/* Staff Assignment Section */}
          {assignStaffToggle && (
            <div className="assignment-section">
              <div className="section-title">Select Staff Members</div>

              <div className="staff-filters">
                <div className="filter-group">
                  <label>Job Title</label>
                  <select
                    value={jobFilter}
                    onChange={(e) => setJobFilter(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="carer">Carer</option>
                    <option value="manager">Manager</option>
                    <option value="supervisor">Supervisor</option>
                    <option value="cook">Cook</option>
                    <option value="kitchen">Kitchen Staff</option>
                    <option value="housekeeping">Housekeeping</option>
                  </select>
                </div>

                <div className="filter-group">
                  <label>Criteria</label>
                  <select
                    value={criteriaFilter}
                    onChange={(e) => setCriteriaFilter(e.target.value)}
                  >
                    <option value="weeklyHoursAssigned">
                      Assigned Shift Hours
                    </option>
                    <option value="distance">Distance</option>
                    <option value="performance">Performance</option>
                  </select>
                </div>
              </div>

              <div className="staff-list">{renderStaffList()}</div>
            </div>
          )}

          {/* Open Shift Section */}
          {openShiftToggle && (
            <div className="open-shift-section active">
              <div className="section-title">Open Shift Details</div>

              <div className="open-shift-group">
                <label>Client Group</label>
                <select
                  value={openShiftGroup}
                  onChange={(e) => setOpenShiftGroup(e.target.value)}
                >
                  <option value="all">All Client</option>
                  {groupArr?.map((elem) => {
                    return (
                      <option key={elem.groupId} value={elem.groupId}>
                        {elem.groupName}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="accepted-staff-section">
                <h4>Staff Accepted by Admin from Dashboard</h4>
                <div className="accepted-staff-list">
                  {renderAcceptedStaff()}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="popup-actions">
          <button className="btn btn-secondary" onClick={closePopup}>
            Cancel
          </button>
          <button
            disabled={loading}
            className="btn btn-primary"
            style={{ minWidth: "160px" }}
            onClick={saveAssignment}
          >
            {loading ? (
              <CircularProgress
                style={{ width: "16px", height: "16px", color: "#fff" }}
              />
            ) : (
              "Save Assignment"
            )}
          </button>
        </div>
      </div>

      {/* Error Popup */}
      {errorModal.show && (
        <div className="popup-overlay">
          <div className="popup" style={{ maxWidth: "500px" }}>
            <div className="popup-header" style={{ background: "#6f42c1" }}>
              <h2 className="popup-title">Alert</h2>
              <button className="close-btn" onClick={closeErrorModal}>
                &times;
              </button>
            </div>

            <div className="popup-content">
              <div style={{ textAlign: "center", padding: "20px" }}>
                <div
                  style={{
                    fontSize: "48px",
                    color: "#6f42c1",
                    marginBottom: "15px",
                  }}
                >
                  ⚠️
                </div>
                <h3 style={{ color: "#5a359a", marginBottom: "15px" }}>
                  {errorModal.title}
                </h3>
                <p
                  style={{
                    color: "#5a359a",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  {errorModal.message}
                </p>
              </div>
            </div>

            <div className="popup-actions">
              <button
                className="btn"
                style={{ background: "#6f42c1", color: "white" }}
                onClick={closeErrorModal}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignStaffNew;
